export const BreadcrumbBar = ({ navStack, labels }: any) => {
  const getLabel = (level: string) => {
    if (labels[level]) return labels[level];
    if (level.startsWith('groupsummary_')) return 'Group Summary';
    if (level.startsWith('display_stocksummary_')) return 'Stock Summary';
    if (level.startsWith('voucher_register_')) return 'Voucher Register';
    if (level.startsWith('register_summary_')) return 'Register Summary';
    return level;
  };

  return (
    <div className="bg-white border-b border-gray-300 px-4 py-1.5 text-xs text-[#1e8585] flex items-center shadow-sm">
      <span className="font-bold cursor-pointer">{navStack.map((s: any) => getLabel(s.level)).join(' > ')}</span>
    </div>
  );
};
